import { Input } from "../../../components/Input/input";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { StyledButton } from "../../../components/Button/button";
import { theme } from "../../../helpers/theme";

// import { FormWrapper } from "../../common-views/forgotten-password-send-mail/styles";
import { useMutation } from "@tanstack/react-query";
import { GetOperatorClientsById } from "../../../services/clients/getById/types";
import { addressAdd } from "../../../services/address/add";
import { ClientUpdate } from "../../../services/clients/edit";
import { toast, ToastOptions } from "react-toastify";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { addressVoivodeshipsList } from "../../../helpers/voievodeshipsList";
import { putAddressUpdate } from "../../../services/address/update";
import React, { useEffect } from "react";

export const AddressForm = (clientData: GetOperatorClientsById[]) => {
  const { id } = useParams();
  const aData = clientData[0];

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  const editAddressMutation = useMutation(putAddressUpdate, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "EditSuccessfully",
        ...settings,
      });
    },
  });

  const EditClientMutation = useMutation(ClientUpdate, {
    onSuccess: (res) => { },
  });

  const addAdressMutation = useMutation(addressAdd, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "EditSuccessfully",
        ...settings,
      });
      const bodyBasic = {
        id_klient: id,
        nazwa: aData.nazwa,
        nip: aData.nip,
        weryfikacja: aData.weryfikacja,
        telefon: aData.telefon,
        email: aData.email,
        info_dodatkowe: aData.info_dodatkowe,
        aktywny: aData.aktywny,
        adres: res.data.payload.id_klient,
      };
      EditClientMutation.mutate(bodyBasic);
    },
  });

  const postalCodeRegExp = /^[0-9]{2}-[0-9]{3}/;

  const validationSchema = yup.object({
    kod_pocztowy: yup
      .string()
      .required("Kod pocztowy jest wymagany")
      .matches(postalCodeRegExp, "Błędny format!")
      .min(6, "Błędny format!")
      .max(6, "Błędny format!"),
    miejscowosc_poczty: yup
      .string(),
    miejscowosc: yup
      .string()
      .max(100, "Miejscowość nie może być dłuższa niż 100 znaków")
      .required("Miejscowość jest wymagana"),
    ulica: yup
      .string()
      .max(100, "Ulica nie może być dłuższa niż 100 znaków"),
    numer_budynku: yup
      .string()
      .max(5, "Numer budynku nie może być dłuższy niż 5 znaków")
      .required("Numer budynku jest wymagany"),
    numer_lokalu: yup
      .number()
      .typeError("Błędny format!")
      .max(99999, "Numer lokalu nie może być dłuższy niż 5 znaków"),
    wojewodztwo: yup
      .string()
      .required("Województwo jest wymagane"),
    kraj: yup
      .string()
      .required("Kraj jest wymagany"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      kod_pocztowy: aData?.adres_klient ? aData.adres_klient.kod_pocztowy : "",
      miejscowosc_poczty: aData?.adres_klient
        ? aData.adres_klient.miejscowosc_poczty
        : "",
      miejscowosc: aData?.adres_klient ? aData.adres_klient.miejscowosc : "",
      ulica: aData?.adres_klient ? aData.adres_klient.ulica : "",
      numer_budynku: aData?.adres_klient ? aData.adres_klient.numer_budynku : "",
      numer_lokalu: aData?.adres_klient ? aData.adres_klient.numer_lokalu : "",
      wojewodztwo: aData?.adres_klient ? aData.adres_klient.wojewodztwo : "",
      kraj: "Polska",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_klient: id,
        kod_pocztowy: values.kod_pocztowy,
        miejscowosc_poczty: values.miejscowosc,
        miejscowosc: values.miejscowosc,
        ulica: values.ulica === "" ? null : values.ulica,
        numer_budynku: values.numer_budynku,
        numer_lokalu: values.numer_lokalu === "" ? null : values.numer_lokalu,
        wojewodztwo: values.wojewodztwo,
        kraj: "Polska",
      };

      if (aData.adres_klient) {
        editAddressMutation.mutate(body);
      } else {
        addAdressMutation.mutate(body);
      }
    },
  });


  return (
    <AddressFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
        <Input
          label="Kod pocztowy"
          id="kod_pocztowy"
          name="kod_pocztowy"
          value={formik.values.kod_pocztowy}
          onChange={formik.handleChange}
          error={
            formik.touched.kod_pocztowy && Boolean(formik.errors.kod_pocztowy)
          }
          helperText={formik.touched.kod_pocztowy && formik.errors.kod_pocztowy}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Miejscowość"
          id="miejscowosc"
          name="miejscowosc"
          value={formik.values.miejscowosc}
          onChange={formik.handleChange}
          error={
            formik.touched.miejscowosc && Boolean(formik.errors.miejscowosc)
          }
          helperText={formik.touched.miejscowosc && formik.errors.miejscowosc}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Ulica"
          id="ulica"
          name="ulica"
          value={formik.values.ulica}
          onChange={formik.handleChange}
          error={formik.touched.ulica && Boolean(formik.errors.ulica)}
          helperText={formik.touched.ulica && formik.errors.ulica}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Numer budynku"
          id="numer_budynku"
          name="numer_budynku"
          value={formik.values.numer_budynku}
          onChange={formik.handleChange}
          error={
            formik.touched.numer_budynku && Boolean(formik.errors.numer_budynku)
          }
          helperText={
            formik.touched.numer_budynku && formik.errors.numer_budynku
          }
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Numer lokalu"
          id="numer_lokalu"
          name="numer_lokalu"
          value={formik.values.numer_lokalu}
          onChange={formik.handleChange}
          error={
            formik.touched.numer_lokalu && Boolean(formik.errors.numer_lokalu)
          }
          helperText={formik.touched.numer_lokalu && formik.errors.numer_lokalu}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <FormControl fullWidth>
          <InputLabel 
            sx={{
              fontSize: "14px",
              font: `${theme.fonts.interRegular}`,
              top: "13px",
              left: "0px",
              zIndex: "100",
              "&.Mui-focused":{
                color:`${theme.colors.gray01_secondaryText}`,
              }     
            }}
          id="wojewodztwoLabel"
          >Województwo</InputLabel>
          <Select
            placeholder="Województwo"
            labelId="wojewodztwoLabel"
            id="wojewodztwo"
            name="wojewodztwo"
            value={formik.values.wojewodztwo}
            label="Województwo"
            onChange={formik.handleChange}
            // disabled={!isEditable}
            variant="filled"
            disableUnderline
            sx={{
              width: "100%",
              backgroundColor: "#fcfcfb",
              borderRadius: "8px",
              "& .MuiFilledInput-root": {
                  color: `${theme.colors.black_primaryText} `,
                  overflow: "hidden",
                  borderRadius: 10,
                  backgroundColor: "#fcfcfb",
                  border: "none",

                  "&:hover": {
                      backgroundColor: `${theme.colors.white} `,

                  },
                  "&.Mui-focused": {
                      backgroundColor: `${theme.colors.gray05_input} `,
                      boxShadow: `rgba(25, 18, 210, 0.25) 0 0 0 2px`,
                      borderColor: `${theme.colors.blue01_active} `,
                  },
              },
              "& .MuiFormLabel-root": {

                  "&.Mui-focused": {
                      color: `${theme.colors.gray01_secondaryText} `,

                  },
              },
              "& .Mui-error": {
                  color: `${theme.colors.red01_alert} `,
                  // "font-size": "12px",//<<<TODO
              }
          }}
          >
            {addressVoivodeshipsList.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Input
          disabled
          label="Kraj"
          id="kraj"
          name="kraj"
          value={formik.values.kraj}
          onChange={formik.handleChange}
          error={formik.touched.kraj && Boolean(formik.errors.kraj)}
          helperText={formik.touched.kraj && formik.errors.kraj}
          onBlur={formik.handleBlur}
          variant="filled"
          sx={{
              width: "100%",
              backgroundColor: `${theme.colors.gray05_input}`,
              borderRadius: "8px",
              "& .Mui-disabled": {
                  backgroundColor: `${theme.colors.gray05_input}`,
                  borderRadius: "8px",
              },
              "&.active, &:hover, &.active:hover": {
                  backgroundColor: `white`,
                  borderRadius: `8px`,

              },
          }}
        />
        <StyledButton
          disabled={
            !formik.isValid ||
            editAddressMutation.isLoading ||
            addAdressMutation.isLoading
          }
          type="submit"
          variant="contained"
        >
          Zapisz
        </StyledButton>
      </FormWrapper>
    </AddressFormWrapper>
  );
};

export default AddressForm;

const AddressFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}) {
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 260px;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;
